import { Component, ChangeDetectorRef, OnInit, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/api.service';
declare var $: any;
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-edit-card',
  templateUrl: './edit-card.component.html',
  styleUrls: ['./edit-card.component.css']
})
export class EditCardComponent implements OnInit, AfterViewInit {
  
  currentStep: number = 2;
  selectedColor: any;
  FirstName: any;
  LastName: any;
  CompanyName: any;
  JobTitle: any;
  ccontent: any;
  Email: any;
  Address: any;
  PhoneNumber: any;
  PhoneNumber2: any;
  PhoneAllow: any;
  ForwardCard: any;
  colorPickerLoaded: boolean = false;
  SaveCard: any;
  InviteCode: any;
  Photo: any;
  Logo: any;
  ProductImages: any;
  YoutubeTitle: any;
  YoutubeLink: any;
  VimeoTitle: any;
  VimeoLink: any;
  UmyotubeTitle: any;
  UmyotubeLink: any;
  LinkButtonTitle: any;
  LinkButtonLink: any;
  FacebookLink: any;
  userPackageId: any;
  Facebook: any;
  Youtube: any;
  Linkedin: any;
  Twitter: any;
  Snapchat: any;
  isLoading: any = true;
  Instagram: any;
  Voxer: any;
  Line: any;
  Pinterest: any;
  Whatsapp: any;
  Skype: any;
  CardTitle: any;
  referalCode: any;
  templateId: any = 1;
  userPackageData: any;
  card_id: any;
  ConvertedPhoto: any;
  ConvertedLogo: any;
  ConvertedProductImage: any;
  iPic: any;
  showLoadingModal: any = false;
  loadingTitle: any = "Please Wait.";
  loadingMessage: any = "Updating Your Card...";
  iLogo: any;
  iProduct: any;

  changeComplete(color: any) {
    this.selectedColor = color.hex;
  }
  
  ngAfterViewInit() {
    this.colorPickerLoaded = true;
    
    const uploadBoxes = document.querySelectorAll('.upload_box');
    uploadBoxes.forEach((box) => {
      box.addEventListener('click', () => {
        const targetId = box.getAttribute('data-target');
        const inputElement = document.getElementById(targetId);
        if (inputElement) {
          inputElement.click();
        }
      });
    });
  }

  Form: FormGroup;
  colorOptions: string[] = ['red', 'green', 'yellow', 'olive', 'orange', 'teal', 'blue', 'violet', 'purple', 'pink'];
  productImagesQuantity: any;
  id = localStorage.getItem('user_id');
  user_id = parseInt(this.id, 10);
  
  config: EditorConfig = {
    placeholder: 'Type something...',
    buttons: ST_BUTTONS,
  };

  convertDataURLtoFile(dataURL: string, fileName: string): File | null {
    if (!dataURL || typeof dataURL !== 'string' || !dataURL.startsWith('data:image')) {
      console.error('Invalid data URL');
      return null;
    }
  
    const byteString = atob(dataURL.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
  
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
  
    const blob = new Blob([ab], { type: 'image/png' });
    return new File([blob], fileName, { type: 'image/png' });
  }

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.params.subscribe((params) => {
      this.card_id = params['id'];
    });
    
    this.Form = this.fb.group({
      selectedColor: ['red'],
      FirstName: [''],
      LastName: [''],
      Gpa: [''],
      Age: [''],
      Height: [''],
      Weight: [''],
      Grade: [''],
      School: [''],
      CompanyName: [''],
      JobTitle: [''],
      ccontent: [''],
      Email: '',
      Address: '',
      PhoneNumber: '',
      PhoneNumber2: '',
      PhoneAllow: [true],
      ForwardCard: [true],
      SaveCard: [true],
      InviteCode: [true],
      Photo: ['assets/images/john-doe-avatar.jpg'],
      Logo: ['assets/images/unmasking-yourself.jpg'],
      ProductImages: [['assets/images/app-devices.jpg']],
      YoutubeTitle: [''],
      YoutubeLink: ['https://www.youtube.com/embed/soXhe4aEsTU'],
      VimeoTitle: [''],
      VimeoLink: [''],
      UmyotubeTitle: [''],
      UmyotubeLink: [''],
      LinkButtonTitle: [''],
      LinkButtonLink: [''],
      FacebookLink: [''],
      YoutubeVideos: this.fb.array([this.createYoutubeVideoGroup()]),
      UmyotubeVideos: this.fb.array([this.createUmyotubeVideoGroup()]),
      VimeoVideos: this.fb.array([this.createVimeoVideoGroup()]),
      LinkButton: this.fb.array([this.createLinkButtonGroup()]),
      Facebook: '',
      Youtube: '',
      Linkedin: '',
      Twitter: '',
      Snapchat: '',
      Instagram: '',
      Voxer: '',
      Line: '',
      Pinterest: '',
      Whatsapp: '',
      Skype: '',
      CardTitle: 'Title',
    });
  }

  createYoutubeVideoGroup() {
    return this.fb.group({
      youtubeTitle: [''],
      youtubeLink: [''],
    });
  }

  createUmyotubeVideoGroup() {
    return this.fb.group({
      umyotubeTitle: [''],
      umyotubeLink: [''],
    });
  }

  createVimeoVideoGroup() {
    return this.fb.group({
      vimeoVideoTitle: [''],
      vimeoVideoLink: [''],
    });
  }

  createLinkButtonGroup() {
    return this.fb.group({
      LinkButtonTitle: [''],
      LinkButtonLink: [''],
    });
  }

  getUmyotubeTitleControl(index: number) {
    return this.UmyotubeVideos.at(index).get('umyotubeTitle') as FormControl;
  }
  
  getUmyotubeLinkControl(index: number) {
    return this.UmyotubeVideos.at(index).get('umyotubeLink') as FormControl;
  }

  getVimeoVideoTitleControl(index: number) {
    return this.VimeoVideos.at(index).get('vimeoVideoTitle') as FormControl;
  }
  
  getVimeoVideoLinkControl(index: number) {
    return this.VimeoVideos.at(index).get('vimeoVideoLink') as FormControl;
  }

  getLinkButtonTitleControl(index: number) {
    return this.LinkButton.at(index).get('LinkButtonTitle') as FormControl;
  }
  
  getLinkButtonLinkControl(index: number) {
    return this.LinkButton.at(index).get('LinkButtonLink') as FormControl;
  }

  getYoutubeTitleControl(index: number) {
    return this.YoutubeVideos.at(index).get('youtubeTitle') as FormControl;
  }
  
  getYoutubeLinkControl(index: number) {
    return this.YoutubeVideos.at(index).get('youtubeLink') as FormControl;
  }

  get YoutubeVideos() {
    return this.Form.get('YoutubeVideos') as FormArray;
  }

  get UmyotubeVideos() {
    return this.Form.get('UmyotubeVideos') as FormArray;
  }

  get VimeoVideos() {
    return this.Form.get('VimeoVideos') as FormArray;
  }

  get LinkButton() {
    return this.Form.get('LinkButton') as FormArray;
  }

  addYoutube() {
    const videoLimit = {
      "1 video link": 1,
      "2 video link": 2,
      "3 video link": 3,
      "Unlimited(General)": Infinity
    };

    const currentVideoCount = this.YoutubeVideos.value.length;
    const maxVideosAllowed = videoLimit[this.userPackageData.videos];

    if (currentVideoCount < maxVideosAllowed) {
      this.YoutubeVideos.push(this.createYoutubeVideoGroup());
      this.cdr.detectChanges();
    } else {
      alert(`You are only allowed to have ${maxVideosAllowed} youtube video link${maxVideosAllowed > 1 ? 's' : ''}`);
    }
  }

  removeYoutube(index: number) {
    this.YoutubeVideos.removeAt(index);
    this.cdr.detectChanges();
  }
 
  addUmyotubeVideos() {
    const videoLimit = {
      "1 video link": 1,
      "2 video link": 2,
      "3 video link": 3,
      "Unlimited(General)": Infinity
    };

    const currentVideoCount = this.UmyotubeVideos.value.length;
    const maxVideosAllowed = videoLimit[this.userPackageData.umyotube];

    if (currentVideoCount < maxVideosAllowed) {
      this.UmyotubeVideos.push(this.createUmyotubeVideoGroup());
      this.cdr.detectChanges();
    } else {
      alert(`You are only allowed to have ${maxVideosAllowed} umyotube video link${maxVideosAllowed > 1 ? 's' : ''}`);
    }
  }

  removeUmyotubeVideos(index: number) {
    this.UmyotubeVideos.removeAt(index);
    this.cdr.detectChanges();
  }

  addVimeoVideos() {
    const videoLimit = {
      "1 video link": 1,
      "2 video link": 2,
      "3 video link": 3,
      "Unlimited(General)": Infinity
    };

    const currentVideoCount = this.VimeoVideos.value.length;
    const maxVideosAllowed = videoLimit[this.userPackageData.vimeo];

    if (currentVideoCount < maxVideosAllowed) {
      this.VimeoVideos.push(this.createVimeoVideoGroup());
      this.cdr.detectChanges();
    } else {
      alert(`You are only allowed to have ${maxVideosAllowed} vimeo video link${maxVideosAllowed > 1 ? 's' : ''}`);
    }
  }

  removeVimeoVideos(index: number) {
    this.VimeoVideos.removeAt(index);
    this.cdr.detectChanges();
  }

  addLinkButton() {
    this.LinkButton.push(this.createLinkButtonGroup());
    this.cdr.detectChanges();
  }

  removeLinkButton(index: number) {
    this.LinkButton.removeAt(index);
    this.cdr.detectChanges();
  }

  onPhotoChange(event: any): void {
    const file = event?.target?.files[0];
    if (file) {
      this.Form.patchValue({ Photo: file });
      this.convertFileToDataURL(file).then((dataUrl) => {
        this.ConvertedPhoto = dataUrl;
        this.cdr.detectChanges();
      });
    }
  }

  onLogoChange(event: any): void {
    if (this.userPackageData.logo === "No") {
      alert("You are not allowed to upload a logo in your current package.");
      return;
    }
  
    if (this.userPackageId === 14) {
      alert("You are not allowed to update your logo image in your current package.");
      return;
    }
  
    const file = event?.target?.files[0];
    if (file) {
      this.Form.patchValue({ Logo: file });
      this.convertFileToDataURL(file).then((dataUrl) => {
        this.ConvertedLogo = dataUrl;
        this.cdr.detectChanges();
      }).finally(() => {
        this.cdr.detectChanges();
      });
    }
  }

  populateYoutube(formArrayName: string, data: any[]) {
    const formArray = this.Form.get(formArrayName) as FormArray;
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
    if (data && data.length > 0) {
      for (const item of data) {
        formArray.push(this.fb.group({
          youtubeTitle: item.youtubeTitle || '',
          youtubeLink: item.youtubeLink || '',
        }));
      }
    }
  }

  populateUmyotube(formArrayName: string, data: any[]) {
    const formArray = this.Form.get(formArrayName) as FormArray;
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
    if (data && data.length > 0) {
      for (const item of data) {
        formArray.push(this.fb.group({
          umyotubeTitle: item.umyotubeTitle || '',
          umyotubeLink: item.umyotubeLink || '',
        }));
      }
    }
  }

  populateVimeo(formArrayName: string, data: any[]) {
    const formArray = this.Form.get(formArrayName) as FormArray;
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
    if (data && data.length > 0) {
      for (const item of data) {
        formArray.push(this.fb.group({
          vimeoVideoTitle: item.vimeoVideoTitle || '',
          vimeoVideoLink: item.vimeoVideoLink || '',
        }));
      }
    }
  }

  populateLink(formArrayName: string, data: any[]) {
    const formArray = this.Form.get(formArrayName) as FormArray;
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
    if (data && data.length > 0) {
      for (const item of data) {
        formArray.push(this.fb.group({
          LinkButtonTitle: item.LinkButtonTitle || '',
          LinkButtonLink: item.LinkButtonLink || '',
        }));
      }
    }
  }

  onProductImagesChange(event: any): void {
    const files = event?.target?.files;
    if (files) {
      const base64Images = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          base64Images.push(reader.result);
          if (base64Images.length === files.length) {
            this.Form.patchValue({ ProductImages: base64Images });
            this.ConvertedProductImage = base64Images;
            this.cdr.detectChanges();
          }
        };
      }
    }
  }

  nextStep() {
    if (this.currentStep < 6) {
      this.goToStep(this.currentStep + 1);
    }
  }

  prevStep() {
    if (this.currentStep > 2) {
      this.goToStep(this.currentStep - 1);
    }
  }

  goToStep(step: number): void {
    const forward = step > this.currentStep;

    $(`.step-${this.currentStep}`).fadeOut(300, () => {
      $('.step').hide();
      this.currentStep = step;
      $(`.step-${this.currentStep}`).fadeIn(300);
      this.updateProgressBar();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.cdr.detectChanges();
    });
  }

  ngOnInit(): void {
    this.isLoading = true;
    
    // Hide all steps first
    $('.step').hide();
    
    const payload = {
      user_id: this.id,
      card_id: this.card_id
    };
    
    this.apiService.getSingleCard(payload).subscribe(
      (response) => {
        if (response.status == 'Success') {
          const socialFormData = response.Card.socialFormData;

          this.populateYoutube('YoutubeVideos', socialFormData.youtubeVideos);
          this.populateUmyotube('UmyotubeVideos', socialFormData.umyotubeVideos);
          this.populateVimeo('VimeoVideos', socialFormData.vimeoVideos);
          this.populateLink('LinkButton', socialFormData.linkButtons);

          this.templateId = response.Card.infoFormData.templateId;
          this.selectedColor = response.Card.colorTheme;
          
          this.Form.patchValue({
            selectedColor: response.Card.colorTheme,
            CardTitle: response.Card.infoFormData.cardTitle,
            FirstName: response.Card.infoFormData.firstName,
            LastName: response.Card.infoFormData.lastName,
            CompanyName: response.Card.infoFormData.companyName,
            JobTitle: response.Card.infoFormData.jobTitle,
            ccontent: response.Card.infoFormData.aboutText,
            Email: response.Card.infoFormData.email,
            Address: response.Card.infoFormData.address,
            PhoneNumber: response.Card.infoFormData.phoneNumber,
            PhoneNumber2: response.Card.infoFormData.alternativePhoneNo,
            PhoneAllow: response.Card.infoFormData.phoneTextAllow,
            ForwardCard: response.Card.infoFormData.showForwardButton,
            SaveCard: response.Card.infoFormData.showSaveButton,
            InviteCode: response.Card.infoFormData.showInviteCode,
            Gpa: response.Card.infoFormData.gpa,
            Age: response.Card.infoFormData.age,
            Weight: response.Card.infoFormData.weight,
            Height: response.Card.infoFormData.height,
            Grade: response.Card.infoFormData.grade,
            School: response.Card.infoFormData.school,
            Facebook: response.Card.socialFormData.facebook,
            Youtube: response.Card.socialFormData.youtube,
            Linkedin: response.Card.socialFormData.linkedin,
            Twitter: response.Card.socialFormData.twitter,
            Snapchat: response.Card.socialFormData.snapchat,
            Instagram: response.Card.socialFormData.instagram,
            Voxer: response.Card.socialFormData.voxerID,
            Line: response.Card.socialFormData.lineID,
            Pinterest: response.Card.socialFormData.pinterest,
            Whatsapp: response.Card.socialFormData.whatsappID,
            Skype: response.Card.socialFormData.skypeID
          });
          
          this.Form.get('Photo').setValue(this.convertDataURLtoFile(response.Card.change_photo, 'photo'));
          this.Form.get('Logo').setValue(this.convertDataURLtoFile(response.Card.change_logo, 'logo'));
          this.Form.get('ProductImages').setValue(JSON.parse(response.Card.changeProductImages));
          
          this.iPic = response.Card.change_photo;
          this.iLogo = response.Card.change_logo;
          this.iProduct = response.Card.changeProductImages;
          this.referalCode = response.Card.infoFormData.inviteCode;
        }
        
        this.apiService.getUserById(this.user_id).subscribe(
          (userResponse) => {
            if (userResponse.status === 'Success') {
              this.userPackageData = userResponse.Users.PackageData;
              this.userPackageId = userResponse.Users.package_id;
            }
            this.isLoading = false;
            this.cdr.detectChanges();
            
            // Show step-2 after data is loaded
            setTimeout(() => {
              $('.step').hide();
              $('.step-2').show();
              this.currentStep = 2;
              this.updateProgressBar();
            }, 100);
          },
          (error) => {
            this.isLoading = false;
            console.log('error fetching user data');
          }
        );
      },
      (error) => {
        this.isLoading = false;
        alert('failed to fetch card' + error.message);
      }
    );
  }

  updateProgressBar() {
    const progressPercentage = ((this.currentStep - 2) / 4) * 100;
    $('.progress-bar').css('width', progressPercentage + '%');
  }

  convertFileToDataURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target && typeof event.target.result === 'string') {
          resolve(event.target.result);
        } else {
          reject(new Error('Failed to convert file to data URL.'));
        }
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }

  saveCard() {
    this.showLoadingModal = true;
    
    const youtubeVideosArray = this.Form.get('YoutubeVideos') as FormArray;
    const umyotubeVideosArray = this.Form.get('UmyotubeVideos') as FormArray;
    const vimeoVideosArray = this.Form.get('VimeoVideos') as FormArray;
    const LinkButtonArray = this.Form.get('LinkButton') as FormArray;
    
    const youtubeData = youtubeVideosArray.controls.map((control) => {
      return {
        youtubeTitle: control.get('youtubeTitle').value,
        youtubeLink: control.get('youtubeLink').value
      };
    });
    
    const umyotubeData = umyotubeVideosArray.controls.map((control) => {
      return {
        umyotubeTitle: control.get('umyotubeTitle').value,
        umyotubeLink: control.get('umyotubeLink').value
      };
    });
    
    const vimeoVideosData = vimeoVideosArray.controls.map((control) => {
      return {
        vimeoVideoTitle: control.get('vimeoVideoTitle').value,
        vimeoVideoLink: control.get('vimeoVideoLink').value
      };
    });
    
    const linkButtonData = LinkButtonArray.controls.map((control) => {
      return {
        LinkButtonTitle: control.get('LinkButtonTitle').value,
        LinkButtonLink: control.get('LinkButtonLink').value
      };
    });

    const SocialFormData = {
      facebook: this.Form.value.Facebook,
      twitter: this.Form.value.Twitter,
      youtube: this.Form.value.Youtube,
      instagram: this.Form.value.Instagram,
      linkedin: this.Form.value.Linkedin,
      pinterest: this.Form.value.Pinterest,
      skypeID: this.Form.value.Skype,
      whatsappID: this.Form.value.Whatsapp,
      snapchat: this.Form.value.Snapchat,
      lineID: this.Form.value.Line,
      voxerID: this.Form.value.Voxer,
      youtubeVideos: youtubeData,
      vimeoVideos: vimeoVideosData,
      umyotubeVideos: umyotubeData,
      linkButtons: linkButtonData,
    };

    const infoFormData = {
      templateId: this.templateId,
      cardTitle: this.Form.value.CardTitle,
      firstName: this.Form.value.FirstName,
      lastName: this.Form.value.LastName,
      email: this.Form.value.Email,
      phoneNumber: this.Form.value.PhoneNumber,
      alternativePhoneNo: this.Form.value.PhoneNumber2,
      companyName: this.Form.value.CompanyName,
      jobTitle: this.Form.value.JobTitle,
      address: this.Form.value.Address,
      aboutText: this.Form.value.ccontent,
      phoneTextAllow: this.Form.value.PhoneAllow,
      showSaveButton: this.Form.value.SaveCard,
      showForwardButton: this.Form.value.ForwardCard,
      showInviteCode: this.Form.value.InviteCode,
      inviteCode: this.referalCode,
      gpa: this.Form.value.Gpa,
      age: this.Form.value.Age,
      height: this.Form.value.Height,
      weight: this.Form.value.Weight,
      grade: this.Form.value.Grade,
      school: this.Form.value.School,
    };

    let formData = {
      buttonColor: this.Form.value.selectedColor,
      cardTitle: this.Form.value.CardTitle,
      change_logo: this.iLogo,
      change_photo: this.iPic,
      changeProductImages: this.iProduct,
      colorTheme: this.Form.value.selectedColor,
      user_id: this.id,
      card_id: this.card_id,
      infoFormData: JSON.stringify(infoFormData),
      socialFormData: JSON.stringify(SocialFormData),
    };

    if (this.ConvertedPhoto != null && this.ConvertedPhoto != '' && this.ConvertedPhoto != undefined) {
      formData.change_photo = this.ConvertedPhoto;
    }

    if (this.ConvertedLogo != null && this.ConvertedLogo != '' && this.ConvertedLogo != undefined) {
      formData.change_logo = this.ConvertedLogo;
    }

    if (this.ConvertedProductImage != null && this.ConvertedProductImage != '' && this.ConvertedProductImage != undefined) {
      formData.changeProductImages = JSON.stringify(this.ConvertedProductImage);
    }

    this.apiService.updateCard(formData).subscribe(
      (response) => {
        if (response.status != 'Failed') {
          this.showLoadingModal = false;
          alert("Card Updated!");
          this.router.navigate(['/cards']);
        } else {
          this.showLoadingModal = false;
          alert("Failed! " + response.message);
        }
      },
      (error) => {
        this.showLoadingModal = false;
        alert("Failed! " + error);
      }
    );
  }
}